import * as Sentry from '@sentry/browser';
import { HttpClient } from '@sentry/integrations';
import { Product } from 'hydra-data-types';
import { Environment } from './Environment';

export const Errors = {
  initialize,
  capture,
  breadcrumb,
  setUser,
};

/** Initialize the Sentry client */
function initialize(): void {
  Sentry.init({
    dsn: 'https://e62532711e45165d374a7c0ab626fb2c@o359120.ingest.us.sentry.io/4509127502921728',
    environment: Environment.isProduction() ? 'production' : 'development',
    release: `${Product.Connect}@${Environment.VERSION}`,
    ...sentryIntegrations(),
  });
}

function sentryIntegrations(): Sentry.BrowserOptions {
  return {
    integrations: [new HttpClient()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
    ignoreErrors: [
      // Segment's analytics destinations (e.g. Google Analytics) fail to load when
      // users have ad blockers or content blockers enabled. These are not actionable.
      /^Failed to load https:\/\/www\.googletagmanager\.com/,
    ],
  };
}

/** Record an error in Sentry */
function capture(error: Error | unknown, level?: Sentry.SeverityLevel): void {
  console.warn(`Error.capture(${JSON.stringify(error)})`, error);

  if (error instanceof Error) {
    // Use original error if possible to preserve the stack trace
    Sentry.captureException(error, { level });
  } else {
    Sentry.captureException(new Error(`${JSON.stringify(error)}`), { level });
  }
}

/** Record a breadcrumb in Sentry */
function breadcrumb(message: string, data?: Record<string, any>): void {
  Sentry.addBreadcrumb({ category: 'Manual', message, data });
}

/** Set the user in Sentry. Pass `undefined` to unset the user. */
function setUser(userId: string | undefined): void {
  Sentry.setUser(userId !== undefined ? { id: userId } : null);
}
